<template>
  <div class="ksm-texte__start-wrapper">
    <div class="ksm-texte__start-bg"></div>
    <div class="ksm-texte__start">
      <div class="ksm-merz-container">
        <img class="ksm-merz-png" src="static/icons/schwitters_hefte_2019_01_p01.png">
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "modusstart",
  data() {
    return {
      rendered: false
    };
  },
  watch: {
    merzListe() {
      this.updateSvg();
    }
  },
  mounted() {
    this.updateSvg();
  },

  methods: {
    gotoPage(merzId) {
      this.$router.push({
        path: "/texte/merzhefte/ansichtsmodus?merzId=" + merzId + "&seiteIdx=0"
      });
    },
    updateSvg() {
      //<g class="st1">
      //<path class="st2"
      //<rect x="686.1" y="384.4" class="st0" width="81.6" height="128.2"/>

      if (!this.merzListe || this.rendered) {
        return;
      }
      const vue = this;

      //create svg from file
      // const svgstr = this.$_getSvg("schwitters_hefte_felder.svg");

      const svgstr = this.$_getSvg(
        "schwitters_hefte_auswahl_RD_web-felder-nr3.svg"
      );

      const div = document.createElement("div");
      div.innerHTML = svgstr;
      const svg = div.firstChild;
      svg.style.width = "100%";
      svg.style.height = "100%";

      //add svg
      this.$el.querySelector(".ksm-merz-container").appendChild(svg);

      const merzListe = this.merzListe;
      const rects = svg.querySelectorAll("rect");
      const title_g = this.$el.querySelectorAll(".st1");
      const uses = svg.querySelectorAll("use");
      for (const u of uses) {
        d3.select(u).style("fill", null);
      }
      // return;
      let merz241_g_clone;
      let merz242_g;
      let x = 0.0,
        y = 0.0;
      let add = false;
      for (const g of title_g) {
        add = false;
        if (g.getAttribute("id")) {
          const rect_id = g.getAttribute("id").replace("_g", "_");

          if (rect_id === "SVGID_st241_") {
            merz241_g_clone = g.cloneNode(true);
            add = true;
          }
          if (rect_id === "SVGID_st242_") {
            merz242_g = g;
            add = true;
          }
          for (const rect of rects) {
            if (rect.getAttribute("id") === rect_id) {            
              if (add) {
                x = parseFloat(d3.select(rect).attr("x"));
                y += parseFloat(d3.select(rect).attr("height"));
              }
              if (!rect.classList.contains("st0")) {
                g.insertBefore(rect.parentNode.parentNode, g.firstChild);
              } else {
                g.insertBefore(rect, g.firstChild);
              }
            }
          }
          d3.select(g)
            .on("mouseover", function() {
              g.classList.remove("hide_merz_rect");
              g.classList.add("show_merz_rect");
            })
            .on("mouseout", function() {
              g.classList.remove("show_merz_rect");
              g.classList.add("hide_merz_rect");
            })
            .on("click", function() {
              g.classList.remove("show_merz_rect");
              g.classList.add("hide_merz_rect");
              if (rect_id === "SVGID_st132_" || rect_id === "SVGID_st242_") {
                vue.$router.push({
                  path: "/texte/ursonate"
                });
                return;
              }

              const merz = merzListe.find(merz => merz.svgID === rect_id);
              if (merz) {
                vue.gotoPage(merz.id);
              }
            });

          g.classList.add("hide_merz_rect");
        }
      }

      /// add text merz 24 ursonate
      merz241_g_clone.removeAttribute("id");
      merz241_g_clone.classList.remove("hide_merz_rect");
      d3.select(merz241_g_clone)
        .remove("class", "hide_merz_rect")
        .attr(
          "transform",
          "scale(0.6) translate(" + x / 1.43 + "," + (y * 4 + 10) + ")"
        );
      svg.appendChild(merz241_g_clone);

      this.rendered = true;
    }
  },
  computed: {
    merzListe() {
      return this.$store.getters.texte.merzListe;
    }
  }
};
</script>

<style lang="scss">
$textColor: rgb(75, 129, 130);
$titleBg: rgb(197, 214, 213);
.ksm-texte__start-wrapper {
  @extend .ksm-flex-x-center;
  @extend .ksm-flex-1;
  padding: 60px;
  position: relative;
}

.ksm-texte__start-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.ksm-texte__start {
  @extend .ksm-flex;
  z-index: 100;
  max-width: 1400px;
  position: relative;
  width: 100%;
  height: 100%;
}

.ksm-merz-container {
  flex: 1;
  position: relative;
  @extend .ksm-flex;
  justify-content: center;
  align-items: center;
  .ksm-merz-png {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    z-index: 99;
  }

  .show_merz_rect {
    opacity: 1 !important;
    use {
      opacity: 0.5;
      stroke: $darkRed !important;
      stroke-width: 2px;
      fill: $darkRed !important;
    }
    * {
      cursor: pointer;
    }
  }

  .hide_merz_rect {
    * {
      fill: transparent;
    }
  }

  rect.st0 {
    opacity: 0.5;
  }

  svg {
    width: 100% !important;
    height: 100% !important;
    z-index: 100;
  }
}
</style>


// WEBPACK FOOTER //
// Start.vue?64832407